// extracted by mini-css-extract-plugin
export default {"modal-background":"ModalBackground_modal-background__5K0Jn"};